import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./AddTurnoverModal.css";

const AddTurnoverModal = (props) => {
  if (!props.visible) return null; // don’t render if not visible

  return (
    <div className="modal">
      <div className="modalContentTurnover">
        <CloseIcon className="closeBtn" onClick={props.onBackdropPress} />
        <h4 className="modalHeadingTurnover">{props.turnoverModalHeading}</h4>

        <input
          type="text"
          placeholder="Enter turnover description"
          className="modalInputTurnover"
          value={props.newTurnover}
          onChange={(e) => props.setNewTurnover(e.target.value)}
        />

        <div className="btnGroup">
          <button className="cancelBtn" onClick={props.onBackdropPress}>
            Cancel
          </button>
          <button className="saveBtn" onClick={props.handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddTurnoverModal;
